export default __webpack_public_path__ + "media/images/Masto-J1-animaux-5f4529e01f090fbac2f75871a6f1addb.png";